import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PrincipalPage from '../components/principal-page/PrincipalPage.vue'
import RegisterPrincipal from '../components/principal-page/session/RegisterPrincipal.vue'
import LoginPrincipal from '../components/principal-page/session/LoginPrincipal.vue'
import { i18n } from '../i18n'
import store from '@/store'
import MainLayout from '@/layouts/MainLayout.vue'
import AcademyView from '@/views/AcademyView.vue'
import GroupsView from '@/views/GroupsView.vue'
import CourseView from '@/views/CourseView.vue'
import AcademyActivitiesLayout from '@/layouts/AcademyActivitiesLayout.vue'
import GroupsManagementView from '@/views/GroupsManagementView.vue'
import CreateGroupsManagement from '@/views/CreateGroupsManagement.vue'
import GroupsManagementViewTest from '@/views/TestEducationalInstitutions/GroupsManagementViewTest.vue'
import CreateGroupsManagementTest from '@/views/TestEducationalInstitutions/CreateGroupsManagementTest.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    beforeEnter: (to, from, next) => {
      const isAuthenticated = store.getters['auth/isAuthenticated'];
      if (isAuthenticated) {
        next(`/${i18n.locale}/home`);
      } else {
        next(`/${i18n.locale}/principal-page`);
      }
    }
  },
  {
    path: "/:lang",
    component: {
      render(c) { return c('router-view')}
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: HomeView,
        meta: { requiresAuth: true, layout: MainLayout },
      },
      {
        path: 'template/:activityId',
        name: 'guide',
        component: () => import('../views/NewProjectBlank.vue'),
        meta: {
          requiresAuth: true,
          isTemplate: true,
          isActivity: false
        },
      },
      { 
        path: "course/:activityId",
        name: "course", 
        component: () => import('../views/CourseView.vue'),
        meta: { requiresAuth: true },
        props: true 
      },
      {
        path: 'board/:id',
        name: 'blank',
        component: () => import('../views/NewProjectBlank.vue'),
        meta: { 
          requiresAuth: true, 
          layout: MainLayout,
          isTemplate: false,
          isActivity: false
        },
      },
      {
        path: 'activity/:activityId',
        name: 'activity',
        component: () => import('../views/NewProjectBlank.vue'),
        meta: { 
          requiresAuth: true,
          isTemplate: false, 
          isActivity: true
        },
      },           
      {
        path: 'projects',
        name: 'all-projects',
        component: () => import('../views/projects/MyProject.vue'),
        meta: { requiresAuth: true, layout: MainLayout },
      },
      {
        path: 'recommended-projects',
        name: 'recommended-projects',
        component: () => import('../views/RecommendedProjectsView.vue'),
        meta: { requiresAuth: true, layout: MainLayout },
      },
      {
        path: 'academy',
        name: 'academy',
        component: AcademyView,
        meta: { requiresAuth: true }
      },
      {
        path: 'academy/course/:courseId',
        name: 'course-view',
        component: CourseView,
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'groups',
        name: 'groups',
        component: GroupsView,
        meta: {
          requiresAuth: true
        }
      },
            {
        path: 'create-groups-management-test/groups-test/:studentId',
        name: 'create-groups-management-test/groups-test',
        component: () => import('@/views/TestEducationalInstitutions/StudentBackofficeTest.vue'),
        props: true
      },
      {
        path: 'student/:studentId',
        name: 'student-backoffice',
        component: () => import('@/views/StudentBackofficeView.vue'),
        props: true
      },
      {
        path: '/:lang/class-activity/:activityId?',
        name: 'class-activity',
        component: () => import('../views/ClassActivityView.vue'),
        meta: { 
            requiresAuth: true,
            layout: null
        }
      },
      {
        path:'principal-page',
        name: 'principal-page',
        component: PrincipalPage,
        meta: { layout: MainLayout },
      },
      {
        path:'principal-page/register',
        name: 'register-principal',
        component: RegisterPrincipal,
        meta: { layout: MainLayout },
      },
      {
        path:'principal-page/login',
        name: 'login-principal',
        component: LoginPrincipal,
        meta: { layout: MainLayout },
      },
      {
        path: 'grades/:groupId',
        name: 'grades',
        component: () => import("../views/GradesView.vue"),
        meta: { requiresAuth: true },
        props: true
      },
      {
        path: '/:lang/groups-management',
        name: 'groups-management',
        component: GroupsManagementView,
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/:lang/create-groups-management',
        name: 'create-groups-management',
        component: CreateGroupsManagement,
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/:lang/create-groups-management-test',
        name: 'create-groups-management-test',
        component: CreateGroupsManagementTest,
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/:lang/groups-management-test',
        name: 'groups-management-test',
        component: GroupsManagementViewTest,
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/:lang/practical-guides-management',
        name: 'practical-guides-management',
        component: () => import('@/views/PracticalGuidesManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/:lang/practical-guides/:category',
        name: 'practical-guides-category',
        component: () => import('@/views/PracticalGuidesCategoryView.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/:lang/practical-guide/:guideId',
        name: 'practical-guide-template',
        component: () => import('@/views/NewProjectBlank.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          isTemplate: true,
          isActivity: false,
          isPracticalGuide: true
        }
      },
      {
        path: 'group-activity-table/:activityId',
        name: 'group-activity-table',
        component: () => import('../views/GroupActivityTableView.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/:lang/edit/course/:courseId',
        name: 'student-backoffice-test',
        component: () => import('@/views/TestEducationalInstitutions/StudentBackofficeTest.vue'),
        props: true
      },
      {
        path: '/:lang/educational-institutions-management',
        name: 'educational-institutions-management',
        component: () => import('@/views/EducationalInstitutionsManagement.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '*',
        beforeEnter: (to, from, next) => {
          const isAuthenticated = store.getters['auth/isAuthenticated'];
          if (isAuthenticated) {
            next(`/${i18n.locale}/home`);
          } else {
            next(`/${i18n.locale}/principal-page`);
          }
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// Define una lista de idiomas válidos
const validLanguages = ['pt', 'es', 'en'];

// Agrega una guarda de navegación en Vue Router
router.beforeEach((to, from, next) => {
  // Obtiene el idioma de la ruta o establece uno predeterminado si no se proporciona
  let language = to.params.lang || 'es';

  // Valida si el idioma es válido
  if (validLanguages.includes(language)) {
    // Si es válido, establece el idioma en i18n
    i18n.locale = language;
    next();
  } else {
    // Si el idioma no es válido, redirige a la ruta predeterminada
    next(`/${i18n.locale}${to.path}`);
  }
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user = store.getters['auth/isAuthenticated']
  
  // Si el usuario intenta ir a login pero ya está autenticado, redirigir a home
  if (to.path === `/${i18n.locale}/principal-page/login` && user) {
    next(`/${i18n.locale}/home`)
  } 
  // Si la ruta requiere autenticación y el usuario no está autenticado, redirigir a login
  else if (requiresAuth && !user) {
    next(`/${i18n.locale}/principal-page/login`)
  } 
  // Si la ruta es principal-page y el usuario está autenticado, redirigir a home
  else if (to.name === 'principal-page' && user) {
    next(`/${i18n.locale}/home`)
  }
  // En cualquier otro caso, continuar con la navegación
  else {
    next()
  }
});

/* Antes de cambiar de ruta, si estamos saliendo de una vista de tipo "canvas" (guide, blank, activity o practical-guide-template), 
se cierran automáticamente los sidebars relacionados con la barra de herramientas para evitar que queden abiertos. */

router.beforeEach((to, from, next) => {
  const canvasRoutes = ['guide', 'blank', 'activity', 'practical-guide-template'];
  const sidebarsToClose = ['sidebar-components', 'sidebar-table'];

  if (canvasRoutes.includes(from.name)) {
    sidebarsToClose
      .filter(sidebar => store.state.sidebars[sidebar])
      .forEach(sidebar => store.commit('closeSidebar', sidebar));
  }

  next();
});


export default router;